import { useRouteBodyState } from "@-/dev.improve.haniverse.lib.navigation.route-body-state";
import type { ReferenceWordMorphemeSlice } from "@-/dev.improve.haniverse.lib.morpheme.entities";
import type { MorphemeInfoPanelAccordionSectionDescriptor } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content._components.morpheme-info-panel-accordion";
import { MorphemeInfoPanelDictionaryWordSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.dictionary.__sections.overview._sections.word-section";
import { MorphemeInfoPanelDictionaryRankSection } from "@-/dev.improve.haniverse.routes.nav.app._components.morpheme.panels._components.panel-content.views.dictionary.__sections.overview._sections.rank-section";
import { Separator } from "@-/dev.improve.haniverse.components.ui.separator";
import { toDiacriticPinyin } from "@-/dev.improve.haniverse.lib.morpheme.grapheme.pinyin";
import { useMemo } from "react";
import { View } from "@-/com.npmjs.react-native";

export function useMorphemeInfoPanelDictionaryOverviewWordSection({
  wordCard,
}: {
  wordCard: ReferenceWordMorphemeSlice;
}): MorphemeInfoPanelAccordionSectionDescriptor {
  const [isOpen, setIsOpen] = useRouteBodyState(
    "use-morpheme-info-panel-dictionary-overview-word-section.tsx:isOpen",
    true,
  );

  // A word keeps its reading on the first definition rather than a `pinyinList` of its own.
  const pinyinList = useMemo(() => {
    const primaryToneNumbersPinyin = wordCard.definitionList[0]?.pinyin;
    return primaryToneNumbersPinyin === undefined
      ? []
      : [toDiacriticPinyin(primaryToneNumbersPinyin)];
  }, [wordCard.definitionList]);

  return {
    bodyKey: "morpheme-info-dictionary-word-overview-body",
    headerKey: "morpheme-info-dictionary-word-overview-header",
    iconName: "LuBookOpen",
    isOpen,
    onToggle: () => setIsOpen((previousState) => !previousState),
    renderBody: () => (
      <View className="pb-0">
        <View className="flex-col">
          <MorphemeInfoPanelDictionaryWordSection pinyinList={pinyinList} wordCard={wordCard} />

          <Separator />

          <View className="self-stretch py-2">
            <View className="px-3">
              <MorphemeInfoPanelDictionaryRankSection infoBackCardSlice={wordCard} />
            </View>
          </View>
        </View>
      </View>
    ),
    title: "Overview",
  };
}
